import { Component, OnInit } from '@angular/core';
import { SidebarConfig } from 'src/app/core/config/sidebar-config';
import { BreadcrumbService } from 'src/app/core/services/app/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.less']
})

export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Array<BreadcrumbItem> = [];
  isHome: boolean = false;;

  constructor(public _breadcrumbdService: BreadcrumbService) { }

  ngOnInit(): void {
      /** Get current page path from the breadcrimb service */
      this._breadcrumbdService.path$.subscribe(path => {
          path = path.split('?')[0];
          this.isHome = path === '/home' || path === '/';
          this.breadcrumbs = [];
          if (!this.isHome) {
              this.buildBreadCrumbs(path);
          }
      });
  }

  /**
   * Build the breadcrumb items array
   * @param path Current page path
   */
  buildBreadCrumbs(path: string) {
      const splittedPath: Array<string> = path.split('/').slice(0, 3);
      path = splittedPath.join('/');
      (new SidebarConfig()).configs.items.forEach((menu: any) => { // Loops on sidebar configuration
          if (menu.subMenu && menu.subMenu.length > 0) { // Check if page has sub items
              menu.subMenu.forEach((subMenu: any) => {
                  if (subMenu.page === path) {
                      this.breadcrumbs.push({ page: menu.page, title: menu.translate, icon: menu.icon }); // Add parent page
                      this.breadcrumbs.push({ page: subMenu.page, title: subMenu.translate }); // Add current page
                  }
              });
          } else  {
              if (menu.page === path) {
                  this.breadcrumbs.push({ page: menu.page, title: menu.translate, icon: menu.icon }); // Adde page
              } else {
                  splittedPath.forEach(p => { // Build path from the splitted page path
                      if (menu.page === `/${p}`) {
                          this.breadcrumbs.push({ page: menu.page, title: menu.translate, icon: menu.icon });
                      }
                  });
              }
          }
      });
  }

}

interface BreadcrumbItem {
  page?: string;
  title: string;
  icon?: string;
}